__turbopack_context__.v({
  "actions": "ProductCard-module-scss-module__bLI9zW__actions",
  "card-link": "ProductCard-module-scss-module__bLI9zW__card-link",
  "cart-slot": "ProductCard-module-scss-module__bLI9zW__cart-slot",
  "cart-slot-item": "ProductCard-module-scss-module__bLI9zW__cart-slot-item",
  "clickable": "ProductCard-module-scss-module__bLI9zW__clickable",
  "content": "ProductCard-module-scss-module__bLI9zW__content",
  "custom-border": "ProductCard-module-scss-module__bLI9zW__custom-border",
  "icon": "ProductCard-module-scss-module__bLI9zW__icon",
  "image-wrapper": "ProductCard-module-scss-module__bLI9zW__image-wrapper",
  "is-hidden": "ProductCard-module-scss-module__bLI9zW__is-hidden",
  "phone-icon": "ProductCard-module-scss-module__bLI9zW__phone-icon",
  "product-card": "ProductCard-module-scss-module__bLI9zW__product-card",
  "quantity": "ProductCard-module-scss-module__bLI9zW__quantity",
  "quantity-slot": "ProductCard-module-scss-module__bLI9zW__quantity-slot",
  "quick-order": "ProductCard-module-scss-module__bLI9zW__quick-order",
  "tags": "ProductCard-module-scss-module__bLI9zW__tags",
});
